/**
 * TRENDYA — Meta Pixel Deduplication Helper v1.0
 * Génère un event_id UUID unique par événement.
 * Partagé entre Pixel navigateur (fbq) ET CAPI serveur (Releasit/webhook).
 * Stocké en sessionStorage pour éviter les doublons intra-session.
 */
(function () {
  'use strict';

  /* ── UUID generator ───────────────────────────────────────── */
  function generateUUID() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }
    // Fallback ES5
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      var v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  /* ── Session-level event_id (PageView / initiateCheckout) ── */
  function getSessionEventId() {
    var KEY = 'trendya_sess_eid';
    var id = sessionStorage.getItem(KEY);
    if (!id) { id = generateUUID(); sessionStorage.setItem(KEY, id); }
    return id;
  }

  /* ── Fresh event_id (Purchase — TOUJOURS nouveau) ─────────── */
  function freshEventId() {
    return generateUUID();
  }

  /* ── Expose globalement ────────────────────────────────────── */
  window.TrenDYA = window.TrenDYA || {};
  window.TrenDYA.getSessionEventId = getSessionEventId;
  window.TrenDYA.freshEventId      = freshEventId;
  // Pré-génère dès le chargement (utile pour PageView)
  window.TrenDYA._sessEid = getSessionEventId();

  /* ── Debug mode : ?trendya_debug=1 ─────────────────────────── */
  if (window.location.search.indexOf('trendya_debug=1') !== -1) {
    console.log('[TrenDYA Pixel] session event_id =', window.TrenDYA._sessEid);
  }
})();
